var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-pagination" }, [
    _vm.isShowTotal
      ? _c("div", { staticClass: "v-pagination__item" }, [
          _vm._v(" " + _vm._s(_vm.dataTips) + " "),
        ])
      : _vm._e(),
    _vm.totalPage > 1
      ? _c(
          "div",
          { staticClass: "v-pagination__item" },
          [
            _c(
              "a",
              {
                staticClass: "v-pagination__button",
                class: {
                  "v-pagination__button--disabled":
                    _vm.page === 1 || _vm.disabled,
                  "v-pagination__button--border": _vm.border,
                },
                on: {
                  click: function ($event) {
                    return _vm.gotoPage("prev")
                  },
                },
              },
              [_vm._v("<")]
            ),
            _vm._l(_vm.footer, function (footerBtn) {
              return _c(
                "a",
                {
                  key: footerBtn.value,
                  staticClass: "v-pagination__button",
                  class: {
                    "v-pagination__button--active": footerBtn.value == _vm.page,
                    "v-pagination__button--border": _vm.border,
                    "v-pagination__button--disabled": _vm.disabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.gotoPage(footerBtn.value)
                    },
                  },
                },
                [_vm._v(_vm._s(footerBtn.text))]
              )
            }),
            _c(
              "a",
              {
                staticClass: "v-pagination__button",
                class: {
                  "v-pagination__button--disabled":
                    _vm.page >= _vm.totalPage || _vm.disabled,
                  "v-pagination__button--border": _vm.border,
                },
                on: {
                  click: function ($event) {
                    return _vm.gotoPage("next")
                  },
                },
              },
              [_vm._v(">")]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm.isShowTotalPage
      ? _c("div", { staticClass: "v-pagination__item" }, [
          _c("span", [_vm._v(_vm._s(_vm._("第")))]),
          _c(
            "span",
            {
              staticClass: "v-pagination__button--active",
              class: { "v-pagination__button--disabled": _vm.disabled },
            },
            [_vm._v(_vm._s(_vm.page))]
          ),
          _c("span", [_vm._v(_vm._s(_vm._("/%s页", [_vm.totalPage])))]),
        ])
      : _vm._e(),
    _vm.isChangeSize
      ? _c(
          "div",
          { staticClass: "v-pagination__item" },
          [
            _c("span", { staticClass: "v-pagination__text" }, [
              _vm._v(_vm._s(_vm._("每页"))),
            ]),
            _c("v-select", {
              staticClass: "v-pagination__select",
              attrs: {
                size: "S",
                disabled: _vm.disabled,
                options: _vm.pageSizeOptions,
              },
              on: { change: _vm.changeSize },
              model: {
                value: _vm.pageSizeValue,
                callback: function ($$v) {
                  _vm.pageSizeValue = $$v
                },
                expression: "pageSizeValue",
              },
            }),
            _c("span", { staticClass: "v-pagination__text" }, [
              _vm._v(_vm._s(_vm._("条"))),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm.isInputPage
      ? _c(
          "div",
          { staticClass: "v-pagination__item" },
          [
            _c("span", { staticClass: "v-pagination__text" }, [
              _vm._v(_vm._s(_vm._("前往"))),
            ]),
            _c("v-input", {
              staticClass: "v-pagination__input",
              attrs: { disabled: _vm.disabled, size: "S", allow: /^\d+$/ },
              on: {
                change: function ($event) {
                  return _vm.gotoPage(_vm.pageValue)
                },
              },
              model: {
                value: _vm.pageValue,
                callback: function ($$v) {
                  _vm.pageValue = $$v
                },
                expression: "pageValue",
              },
            }),
            _c("span", { staticClass: "v-pagination__text" }, [
              _vm._v(_vm._s(_vm._("页"))),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }